export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.AlzaScoring'

export const PRECISION_FORMATS = { days: 'd. M. YYYY', month: 'M. YYYY', year: 'M. YYYY' }

export const NA_CODES = ['NB', 'NC', 'NG', 'NI', 'NL', 'NN', 'NO', 'NP', 'NQ', 'NR', 'NS', 'NA']
